/** Split search input on commas and whitespace into non-empty terms. */
export function parseSearchTerms(search: string): string[] {
  const terms: string[] = [];
  let current = '';

  for (let i = 0; i < search.length; i++) {
    const char = search[i];
    if (char === ',' || char === ' ' || char === '\t' || char === '\n' || char === '\r') {
      const trimmed = current.trim();
      if (trimmed) {
        terms.push(trimmed);
      }
      current = '';
    } else {
      current += char;
    }
  }

  const trimmed = current.trim();
  if (trimmed) {
    terms.push(trimmed);
  }

  return terms;
}

/** Validate ticket search input (single term needs 3+ chars; multiple terms need 1+ each). */
export function isTicketSearchInputValid(input: string): boolean {
  const trimmed = input.trim();
  if (!trimmed) {
    return true;
  }

  const terms = parseSearchTerms(trimmed);
  if (terms.length === 0) {
    return false;
  }

  if (terms.length === 1) {
    return terms[0].length >= 3;
  }

  return terms.every((term) => term.length >= 1);
}
